import React from "react";
import InputBoxSkeleton from "./InputBoxSkeleton";
import ButtonSkeleton from "./ButtonSkeleton";
import EnrollPatientStyle from "../styles/EnrollPatient.module.css";
import PatientStyle from "../styles/Patient.module.css";
import { InputsSection } from "../components/Modal";

const EnrollPatientSkeleton = () => {
  return (
    <form
      className={EnrollPatientStyle.gridContainer}
      style={{ padding: "1rem" }}
    >
      <div className={EnrollPatientStyle.flexContainer}>
        <div className={EnrollPatientStyle.personal}>
          <div
            className={PatientStyle.enroll_ModalForm_inner}
            style={{ gap: "5rem" }}
          >
            <InputBoxSkeleton style={{ width: "100%" }} />

            <InputsSection customClass={PatientStyle.form_grid_section}>
              <InputBoxSkeleton InputBoxSkeleton style={{ width: "100%" }} />
              <InputBoxSkeleton InputBoxSkeleton style={{ width: "100%" }} />
              <InputBoxSkeleton InputBoxSkeleton style={{ width: "100%" }} />
              <InputBoxSkeleton InputBoxSkeleton style={{ width: "100%" }} />
            </InputsSection>

            <InputsSection
              customClass={PatientStyle.address_section}
              style={{ width: "100%" }}
            >
              <InputBoxSkeleton
                InputBoxSkeleton
                customStyle={{ width: "100%" }}
                style={{ width: "100%" }}
              />
              <InputBoxSkeleton
                InputBoxSkeleton
                customStyle={{ width: "100%" }}
                style={{ width: "100%" }}
              />
            </InputsSection>

            <InputsSection
              customClass={PatientStyle.address_section_2}
              style={{ width: "100%" }}
            >
              <InputBoxSkeleton
                InputBoxSkeleton
                customStyle={{ width: "35%" }}
                style={{ width: "100%" }}
              />
              <InputBoxSkeleton
                InputBoxSkeleton
                style={{ width: "100%" }}
                customStyle={{ width: "35%" }}
              />
              <InputBoxSkeleton
                InputBoxSkeleton
                style={{ width: "100%" }}
                customStyle={{ width: "35%" }}
              />
            </InputsSection>
          </div>
        </div>

        <div
          className={`${EnrollPatientStyle.clinic} ${EnrollPatientStyle.form_grid_section}`}
        >
          <InputBoxSkeleton />
          <InputBoxSkeleton />
          <InputBoxSkeleton />
        </div>
      </div>

      <div className={EnrollPatientStyle.flexContainer}>
        <div className={EnrollPatientStyle.insurance}>
          <div className={EnrollPatientStyle.insuranceContainer}>
            <InputsSection
              customClass={EnrollPatientStyle.insuranceGridSection}
            >
              <InputBoxSkeleton />
              <InputBoxSkeleton />
              <InputBoxSkeleton />
            </InputsSection>

            <InputsSection
              customClass={EnrollPatientStyle.insuranceGridSection}
            >
              <InputBoxSkeleton />
              <InputBoxSkeleton />
              <InputBoxSkeleton />
            </InputsSection>
          </div>
        </div>

        <div className={EnrollPatientStyle.confirmation}>
          <div className={EnrollPatientStyle.confirmationSection}>
            <div className={EnrollPatientStyle.confirmatiobButtonWrapper}>
              <ButtonSkeleton style={{ width: "50%", height: "5rem" }} />
            </div>
            <div style={{ marginTop: "1rem" }}>
              <InputBoxSkeleton />
            </div>
          </div>
        </div>

        {/* Main Enroll Patient Button */}
        <ButtonSkeleton
          style={{ marginTop: "auto", width: "100%", height: "5rem" }}
        />
      </div>
    </form>
  );
};

export default EnrollPatientSkeleton;